import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import Avatar from 'material-ui/Avatar';
import HelpIcon from 'material-ui/svg-icons/action/help';

export default () => {

    const NotFoundTitle = <span className="list-title hide-print">
            <Avatar icon={<HelpIcon/>} className="avatar-title system"/>Not Found</span>;

    return (
        <div className="lists-container">
            <Card>
                <ViewTitle title={NotFoundTitle}/>
                <CardText>
                    Sorry, that page was not found.
                </CardText>
            </Card>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/Fuse/notFound.js